(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club-intro-01"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const clubIntro = document.querySelector('[data-club-intro]');
    const heroImageWrapper = document.querySelector('[data-hero-img]');
    const heroImage = heroImageWrapper?.querySelector('img');

    if (!clubIntro || !heroImage) return;

    let ticking = false;
    const maxScale = 1.25; // Subtle scale effect - grows as you scroll
    let isActive = false;

    function updateScale() {
      const rect = clubIntro.getBoundingClientRect();
      const sectionTop = rect.top;
      const sectionBottom = rect.bottom;
      const sectionHeight = clubIntro.offsetHeight;
      const viewportHeight = window.innerHeight;

      // Check if section is in viewport (hasn't completely scrolled past)
      const isInViewport = sectionBottom > 0;

      if (isInViewport) {
        isActive = true;

        if (sectionTop <= 0) {
          // Section has reached or passed the top - start scaling
          // Scale from 1 (when sectionTop = 0) to maxScale (when sectionBottom = 0)
          // The total scroll distance is from sectionTop = 0 to sectionBottom = 0
          // When sectionTop = 0, sectionBottom = sectionHeight
          // When sectionBottom = 0, sectionTop = -sectionHeight
          // So we track progress from sectionTop = 0 to sectionTop = -sectionHeight
          const totalScrollDistance = sectionHeight;
          const scrolled = Math.abs(sectionTop);
          const scrollProgress = Math.min(scrolled / totalScrollDistance, 1);

          // Apply smooth scale transformation
          const scale = 1 + scrollProgress * (maxScale - 1);
          heroImage.style.transform = `scale(${scale})`;
        } else {
          // Section hasn't reached top yet - no scaling
          heroImage.style.transform = 'scale(1)';
        }
      } else {
        // Section has completely scrolled past - set to max scale
        heroImage.style.transform = `scale(${maxScale})`;
        isActive = false;
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateScale);
        ticking = true;
      }
    }

    // Initial check
    updateScale();

    // Listen for scroll events
    // Using scroll events is appropriate here since we need continuous tracking
    // Intersection Observer would only fire on enter/exit, not during scroll
    window.addEventListener('scroll', onScroll, { passive: true });

    // Listen for resize events to recalculate
    window.addEventListener(
      'resize',
      function () {
        updateScale();
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  function openOneTrustPreferences(event) {
    var trigger = event.target.closest('.trigger-onetrust-popup');
    if (!trigger) return;

    event.preventDefault();

    if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
      window.OneTrust.ToggleInfoDisplay();
      return;
    }

    var cookieBtn = document.getElementById('onetrust-pc-btn-handler');
    if (cookieBtn) cookieBtn.click();
  }

  document.addEventListener('click', openOneTrustPreferences);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-fitter-callout"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('local-fitter-callout')) {
    // Up to this many distinct products keep a visit count at once; visiting one more
    // evicts whichever tracked product was least recently visited (LRU).
    const MAX_TRACKED_PRODUCTS = 3;
    const DAY_MS = 24 * 60 * 60 * 1000;
    // A tracked product's visit count - and a dismissal - both age out after this long.
    const WINDOW_MS = 14 * DAY_MS;
    const VISITS_KEY = 'pxg:pdp-visits';
    const DISMISSED_KEY = 'pxg:fitter-dismissed-until';
    // Shared with assets/store-geolocation.js and src/utils/fittingApi.js - do not rename
    // without updating those too. See docs/adr/0002.
    const PREFERRED_STORE_COOKIE = 'pxg_preferred_store';

    function readTrackedProducts() {
      try {
        const raw = window.localStorage.getItem(VISITS_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(parsed)) return [];

        const now = Date.now();
        return parsed.filter(
          (entry) =>
            entry &&
            typeof entry.handle === 'string' &&
            typeof entry.count === 'number' &&
            typeof entry.lastVisited === 'number' &&
            now - entry.lastVisited < WINDOW_MS
        );
      } catch (error) {
        return [];
      }
    }

    function writeTrackedProducts(entries) {
      try {
        window.localStorage.setItem(VISITS_KEY, JSON.stringify(entries));
      } catch (error) {
        // Storage unavailable (private browsing, quota, disabled) - fail silently.
      }
    }

    // Records a visit for `handle`, evicting the least-recently-visited tracked
    // product if this is a new product and all slots are full. Returns the
    // resulting visit count for `handle`.
    function recordVisit(handle) {
      const entries = readTrackedProducts();
      const now = Date.now();
      let entry = entries.find((item) => item.handle === handle);

      if (entry) {
        entry.count += 1;
        entry.lastVisited = now;
      } else {
        if (entries.length >= MAX_TRACKED_PRODUCTS) {
          entries.sort((a, b) => a.lastVisited - b.lastVisited);
          entries.shift();
        }
        entry = { handle, count: 1, lastVisited: now };
        entries.push(entry);
      }

      writeTrackedProducts(entries);
      return entry.count;
    }

    // Dismissal applies to every product's callout, not just the one it was shown
    // on, so it lives in its own key rather than inside a per-product record.
    function isDismissed() {
      try {
        const until = parseInt(window.localStorage.getItem(DISMISSED_KEY), 10);
        if (!until) return false;
        if (Date.now() >= until) {
          window.localStorage.removeItem(DISMISSED_KEY);
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    }

    function dismiss() {
      try {
        window.localStorage.setItem(DISMISSED_KEY, String(Date.now() + WINDOW_MS));
      } catch (error) {
        // Storage unavailable - fail silently.
      }
    }

    // Read-only here: assets/store-geolocation.js owns writing this cookie. Kept as a
    // cookie (not localStorage) deliberately - see docs/adr/0002.
    function getPreferredStore() {
      try {
        const row = document.cookie.split('; ').find((r) => r.startsWith(`${PREFERRED_STORE_COOKIE}=`));
        const raw = row ? decodeURIComponent(row.split('=').slice(1).join('=')) : null;
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }

    // assets/store-geolocation.js may clear and re-fetch an older cookie on this page load, so
    // wait for its lookup before reading the cookie. It's deferred, so it can load after us.
    function whenPreferredStoreReady() {
      if (window.pxgPreferredStore) return window.pxgPreferredStore.ready;
      if (document.readyState !== 'loading') return Promise.resolve();
      return new Promise((resolve) => {
        document.addEventListener('DOMContentLoaded', () => resolve(window.pxgPreferredStore?.ready), {
          once: true,
        });
      });
    }

    function isUsablePreferredStore(preferred) {
      return Boolean(preferred && typeof preferred.name === 'string' && preferred.name && preferred.name !== 'n/a');
    }

    // `salespersonName`/`salespersonImage` are always written as '' (never omitted) by
    // assets/store-geolocation.js once a store lookup has actually happened, so their
    // presence as keys - even empty - means "already checked," letting us skip a
    // redundant store-detail fetch. Their absence means an older cookie predating this
    // caching, so we fall back to fetching. See docs/adr/0002.
    function hasCachedSalesperson(preferred) {
      return typeof preferred.salespersonName === 'string' && typeof preferred.salespersonImage === 'string';
    }

    // A store only "has Salesperson data" when both the name and image are present.
    function getSalespersonFromPreferred(preferred) {
      const name = preferred.salespersonName.trim();
      const image = preferred.salespersonImage.trim();
      if (!name || !image) return null;
      return { name, image };
    }

    async function fetchStoreDetail(storeName) {
      const res = await fetch(`/apps/pxg/v1/store-detail?name=${encodeURIComponent(storeName)}`, {
        method: 'GET',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      });
      if (!res.ok) return null;
      const data = await res.json().catch(() => null);
      return data && data.store ? data.store : null;
    }

    function findStoreField(store, fieldName) {
      const field = Array.isArray(store.fields) ? store.fields.find((f) => f && f.name === fieldName) : null;
      const value = field && field.value;
      return typeof value === 'string' && value.trim() ? value.trim() : null;
    }

    // A store only "has Salesperson data" when both the name and image are present.
    function getSalesperson(store) {
      const name = findStoreField(store, 'Salesperson');
      const image = findStoreField(store, 'Salesperson image');
      if (!name || !image) return null;
      return { name, image };
    }

    function contactValue(value) {
      return typeof value === 'string' ? value.trim() : '';
    }

    // Without a phone number or an email there is no action for the shopper to take.
    function hasContactMethod(store) {
      return contactValue(store.phone) !== '' || contactValue(store.email) !== '';
    }

    customElements.define(
      'local-fitter-callout',
      class LocalFitterCallout extends HTMLElement {
        connectedCallback() {
          this.closeButton = this.querySelector('[data-local-fitter-callout-dismiss]');
          this.callLink = this.querySelector('[data-local-fitter-callout-call]');
          this.emailLink = this.querySelector('[data-local-fitter-callout-email]');
          this.actions = this.querySelector('[data-local-fitter-callout-actions]');
          this.image = this.querySelector('[data-local-fitter-callout-image]');
          this.messageEl = this.querySelector('[data-local-fitter-callout-message]');
          this.callLabel = this.querySelector('[data-local-fitter-callout-call-label]');

          // Captured before anything mutates the `inert` attribute, so later PostHog
          // calls know whether this was a real reveal or a theme-editor preview.
          this.isTracked = this.hasAttribute('inert');

          if (this.closeButton) {
            this.closeButton.addEventListener('click', () => this.hide('close_button'));
          }
          if (this.callLink) {
            this.callLink.addEventListener('click', () => this.trackContactClick('call'));
          }
          if (this.emailLink) {
            this.emailLink.addEventListener('click', () => this.trackContactClick('email'));
          }

          // Not inert means we're in theme editor design mode (or already revealed) - leave as-is
          // and skip tracking, so previewing the section doesn't affect real visit data.
          if (!this.isTracked) return;

          if (!window.featureToggle || !window.featureToggle.preferredStoreUXEnabled) return;

          const handle = this.dataset.productHandle;
          const threshold = parseInt(this.dataset.visitThreshold, 10) || 3;

          if (!handle || isDismissed()) return;

          this.visitCount = recordVisit(handle);
          if (this.visitCount < threshold) return;

          whenPreferredStoreReady().then(() => this.showForPreferredStore());
        }

        showForPreferredStore() {
          const preferred = getPreferredStore();
          if (!isUsablePreferredStore(preferred)) return;

          if (hasCachedSalesperson(preferred)) {
            // Cookie already has everything we need - no store-detail fetch required.
            const salesperson = getSalespersonFromPreferred(preferred);
            if (!salesperson || !hasContactMethod(preferred)) return;

            this.locationName = preferred.name;
            this.salespersonName = salesperson.name;

            this.populate({ name: preferred.name, phone: preferred.phone, email: preferred.email }, salesperson);
            this.observeAndReveal();
            return;
          }

          // Cookie predates salesperson caching - fall back to a live fetch.
          fetchStoreDetail(preferred.name)
            .then((store) => {
              if (!store) return;

              const salesperson = getSalesperson(store);
              if (!salesperson || !hasContactMethod(store)) return;

              this.locationName = store.name || preferred.name;
              this.salespersonName = salesperson.name;

              this.populate(store, salesperson);
              this.observeAndReveal();
            })
            .catch(() => {
              // Store details unavailable - fail silently, never reveal.
            });
        }

        populate(store, salesperson) {
          if (this.image) {
            this.image.addEventListener('error', () => {
              this.image.hidden = true;
            });
            this.image.src = salesperson.image;
            this.image.alt = salesperson.name;
            this.image.hidden = false;
          }

          if (this.messageEl) {
            const template = this.dataset.messageTemplate || '';
            this.messageEl.textContent = template
              .replace('{fitter_name}', salesperson.name)
              .replace('{fitter_location}', store.name || '');
          }

          const phone = contactValue(store.phone);
          const email = contactValue(store.email);
          let hasAction = false;
          if (this.callLink && phone) {
            if (this.callLabel) {
              this.callLabel.textContent = this.callLabel.textContent.replace('{fitter_location}', store.name || '');
            }
            this.callLink.href = `tel:${phone.replace(/[\s()-]/g, '')}`;
            this.callLink.hidden = false;
            hasAction = true;
          }
          if (this.emailLink && email) {
            this.emailLink.href = `mailto:${email}`;
            this.emailLink.hidden = false;
            hasAction = true;
          }
          if (this.actions) {
            this.actions.hidden = !hasAction;
          }
        }

        // Wait until this section has scrolled into view before revealing, rather than
        // firing as soon as the threshold is met while it's still off-screen.
        observeAndReveal() {
          const observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              observer.disconnect();
              this.reveal();
            },
            { rootMargin: '0px 0px -10% 0px' }
          );
          observer.observe(this);
        }

        trackingProperties(extra = {}) {
          return {
            location_name: this.locationName,
            salesperson_name: this.salespersonName,
            product_name: this.dataset.productTitle,
            visit_count: this.visitCount,
            ...extra,
          };
        }

        reveal() {
          this.removeAttribute('inert');
          this.removeAttribute('aria-hidden');

          // Double rAF so the browser paints the 0fr state before animating to 1fr.
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.classList.add('is-visible');
            });
          });

          if (this.isTracked) {
            window.posthog?.capture('local_fitter_callout_displayed', this.trackingProperties());
          }
        }

        trackContactClick(method) {
          if (this.isTracked) {
            window.posthog?.capture('local_fitter_callout_contact_clicked', this.trackingProperties({ method }));
          }
          this.hide('contact_click');
        }

        hide(trigger) {
          dismiss();
          this.classList.remove('is-visible');

          if (this.isTracked) {
            window.posthog?.capture('local_fitter_callout_dismissed', this.trackingProperties({ trigger }));
          }

          const finish = () => {
            this.setAttribute('inert', '');
            this.setAttribute('aria-hidden', 'true');
          };

          const grid = this.querySelector('.local-fitter-callout__grid');
          if (!grid) {
            finish();
            return;
          }

          const onTransitionEnd = (event) => {
            if (event.target !== grid) return;
            grid.removeEventListener('transitionend', onTransitionEnd);
            finish();
          };
          grid.addEventListener('transitionend', onTransitionEnd);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-orders-handler"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /**
     * Main MetaOrdersHandler class
     */
    class MetaOrdersHandler {
      constructor() {
        this.isProcessing = false;
        this.maxRedirects = 3;
        this.redirectCount = 0;
        this.init();
      }

      /**
       * Initialize the handler
       */
      init() {
        // Only process if we haven't already redirected and we're not in a redirect loop
        if (this.shouldProcess()) {
          this.processMetaOrder();
        }
      }

      /**
       * Check if we should process the meta order
       */
      shouldProcess() {
        // Don't process if already processing
        if (this.isProcessing) {
          return false;
        }

        // Don't process if we've redirected too many times
        if (this.redirectCount >= this.maxRedirects) {
          console.warn('MetaOrdersHandler: Max redirects reached, stopping processing');
          return false;
        }

        // Check if we have the required URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('products') || urlParams.has('coupon');
      }

      /**
       * Process the meta order URL parameters
       */
      processMetaOrder() {
        try {
          this.isProcessing = true;

          const urlParams = new URLSearchParams(window.location.search);
          const productsParam = urlParams.get('products');
          const couponParam = urlParams.get('coupon');

          if (!productsParam && !couponParam) {
            return;
          }

          // Build the new cart URL
          const cartUrl = this.buildCartUrl(productsParam, couponParam);

          if (cartUrl) {
            this.redirectToCart(cartUrl);
          }
        } catch (error) {
          console.error('MetaOrdersHandler: Error processing meta order:', error);
          this.isProcessing = false;
        }
      }

      /**
       * Build the cart URL from meta order parameters
       */
      buildCartUrl(productsParam, couponParam) {
        try {
          let cartPath = '/cart/';
          let discountParam = '';

          // Process products parameter
          if (productsParam) {
            const products = this.parseProducts(productsParam);
            if (products && products.length > 0) {
              const productString = products.map((product) => `${product.variantId}:${product.quantity}`).join(',');
              cartPath += productString;
            }
          }

          // Process coupon parameter
          if (couponParam) {
            const coupon = this.sanitizeCoupon(couponParam);
            if (coupon) {
              discountParam = `?discount=${encodeURIComponent(coupon)}`;
            }
          }

          // If no products, redirect to empty cart
          if (cartPath === '/cart/') {
            return '/cart' + discountParam;
          }

          return cartPath + discountParam;
        } catch (error) {
          console.error('MetaOrdersHandler: Error building cart URL:', error);
          return null;
        }
      }

      /**
       * Parse the products parameter string
       */
      parseProducts(productsParam) {
        try {
          // Decode the URL-encoded string
          const decoded = decodeURIComponent(productsParam);

          // Split by comma and parse each product
          const products = decoded
            .split(',')
            .map((product) => {
              const [variantId, quantity] = product.split(':');

              // Validate variant ID and quantity
              if (!variantId || !quantity) {
                return null;
              }

              const parsedQuantity = parseInt(quantity, 10);
              if (isNaN(parsedQuantity) || parsedQuantity <= 0) {
                return null;
              }

              return {
                variantId: variantId.trim(),
                quantity: parsedQuantity,
              };
            })
            .filter(Boolean); // Remove null entries

          return products;
        } catch (error) {
          console.error('MetaOrdersHandler: Error parsing products:', error);
          return [];
        }
      }

      /**
       * Sanitize the coupon code
       */
      sanitizeCoupon(couponParam) {
        try {
          // Decode the URL-encoded string
          const decoded = decodeURIComponent(couponParam);

          // Basic validation - alphanumeric and common characters only
          const sanitized = decoded.replace(/[^a-zA-Z0-9-_]/g, '');

          // Limit length to prevent abuse
          if (sanitized.length > 50) {
            console.warn('MetaOrdersHandler: Coupon code too long, truncating');
            return sanitized.substring(0, 50);
          }

          return sanitized;
        } catch (error) {
          console.error('MetaOrdersHandler: Error sanitizing coupon:', error);
          return null;
        }
      }

      /**
       * Redirect to the cart URL
       */
      redirectToCart(cartUrl) {
        try {
          // Increment redirect count
          this.redirectCount++;

          // Store redirect count in session storage to prevent loops
          sessionStorage.setItem('metaOrdersRedirectCount', this.redirectCount.toString());

          // Log the redirect for debugging
          // console.log('MetaOrdersHandler: Redirecting to cart:', cartUrl);

          // Perform the redirect
          window.location.href = cartUrl;
        } catch (error) {
          console.error('MetaOrdersHandler: Error redirecting to cart:', error);
          this.isProcessing = false;
        }
      }

      /**
       * Get the current redirect count from session storage
       */
      getRedirectCount() {
        try {
          const count = sessionStorage.getItem('metaOrdersRedirectCount');
          return count ? parseInt(count, 10) : 0;
        } catch (error) {
          return 0;
        }
      }

      /**
       * Reset the redirect count
       */
      resetRedirectCount() {
        try {
          sessionStorage.removeItem('metaOrdersRedirectCount');
          this.redirectCount = 0;
        } catch (error) {
          console.error('MetaOrdersHandler: Error resetting redirect count:', error);
        }
      }
    }

    /**
     * Initialize the handler when the DOM is ready
     */
    function initMetaOrdersHandler() {
      // Check if we're in a redirect loop
      const redirectCount = parseInt(sessionStorage.getItem('metaOrdersRedirectCount') || '0', 10);

      if (redirectCount >= 3) {
        console.warn('MetaOrdersHandler: Redirect loop detected, clearing session');
        sessionStorage.removeItem('metaOrdersRedirectCount');
        return;
      }

      // Initialize the handler
      new MetaOrdersHandler();
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMetaOrdersHandler);
    } else {
      initMetaOrdersHandler();
    }

    // Export for potential external use
    window.MetaOrdersHandler = MetaOrdersHandler;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordions"] && !Shopify.designMode) return;
  try {
    
  function initProductAccordionReviews() {
    document.querySelectorAll('.product-accordions .accordion').forEach(function (details) {
      if (details.dataset.yotpoBound === 'true') {
        return;
      }

      details.dataset.yotpoBound = 'true';
      details.addEventListener('toggle', function () {
        if (!details.open) {
          return;
        }

        if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
          window.yotpoWidgetsContainer.initWidgets();
        } else if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
          window.yotpo.refreshWidgets();
        }
      });
    });
  }

  initProductAccordionReviews();
  document.addEventListener('shopify:section:load', initProductAccordionReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refer-a-friend-dev-tools"]) return;
  try {
    
  function initReferAFriendDevTools() {
    const panel = document.querySelector('[data-refer-a-friend-dev-tools]');
    if (!panel || panel.dataset.referAFriendDevBound === 'true') return;

    panel.dataset.referAFriendDevBound = 'true';

    const targetLabel = panel.querySelector('[data-refer-a-friend-dev-target]');
    const groups = panel.querySelector('[data-refer-a-friend-dev-groups]');
    const referrerGroup = panel.querySelector('[data-refer-a-friend-dev-referrer]');
    const inviteGroup = panel.querySelector('[data-refer-a-friend-dev-invite]');
    const testLinkKey = panel.dataset.testLinkKey || 'TEST-LINK-KEY';
    const testDiscountCode = panel.dataset.testDiscountCode || 'RAF-TEST-50';
    const testIneligibleReason =
      panel.dataset.testIneligibleReason ||
      'You are not eligible for refer-a-friend at this time.';

    function getComponents() {
      return {
        referrer: document.querySelector('refer-a-friend-referrer'),
        invite: document.querySelector('refer-a-friend-invite'),
      };
    }

    function setVisible(element, isVisible) {
      element.classList.toggle('is-visible', isVisible);
    }

    function updateTargetLabel() {
      const { referrer, invite } = getComponents();
      const hasComponent = Boolean(referrer || invite);

      setVisible(panel, hasComponent);

      if (!hasComponent) {
        targetLabel.textContent =
          'No refer-a-friend component found on this page. Be sure you are signed in as a Shopify customer.';
        setVisible(groups, false);
        setVisible(referrerGroup, false);
        setVisible(inviteGroup, false);
        return;
      }

      if (referrer && invite) {
        targetLabel.textContent = 'Found refer-a-friend-referrer and refer-a-friend-invite on this page.';
        setVisible(referrerGroup, true);
        setVisible(inviteGroup, true);
      } else if (referrer) {
        targetLabel.textContent = 'Target: refer-a-friend-referrer';
        setVisible(referrerGroup, true);
        setVisible(inviteGroup, false);
      } else {
        targetLabel.textContent = 'Target: refer-a-friend-invite';
        setVisible(referrerGroup, false);
        setVisible(inviteGroup, true);
      }

      setVisible(groups, true);
    }

    function runReferrerAction(action, referrer) {
      switch (action) {
        case 'referrer-loading':
          referrer.showStep('loading');
          break;
        case 'referrer-signup':
          referrer.setSubmitting(false);
          referAFriendClearInlineError(referrer);
          referrer.showStep('signup');
          break;
        case 'referrer-signup-submitting':
          referrer.showStep('signup');
          referrer.setSubmitting(true);
          break;
        case 'referrer-signup-error':
          referAFriendSetInlineError(referrer, {
            error: 'Please fix the errors below.',
            details: ['First name is required', 'Email must be a valid email address'],
          });
          referrer.showStep('signup');
          break;
        case 'referrer-ineligible':
          referrer.showIneligible(testIneligibleReason);
          break;
        case 'referrer-share':
          referrer.populateShareStep(testLinkKey);
          referrer.showStep('share');
          referAFriendRenderActiveReferrals(
            referrer.querySelector('[data-refer-a-friend-active-referrals-list]'),
            [
              {
                referralType: 'Referrer',
                discountCode: 'RAFABCD120XYZ',
                discountAmount: 25,
                expirationDate: '2027-09-09T07:00:00.000Z',
                friendInfo: { firstName: 'John', lastName: 'Doe', email: 'john@example.com' },
              },
              {
                referralType: 'Referrer',
                discountCode: 'RAFMNOP456PXG',
                discountAmount: 25,
                expirationDate: '2027-12-31T07:00:00.000Z',
                friendInfo: { firstName: 'Jane', lastName: 'Smith', email: 'jane@example.com' },
              },
            ]
          );
          referrer.querySelector('[data-refer-a-friend-active-referrals-loading]')?.classList.add('hidden');
          referrer.querySelector('[data-refer-a-friend-active-referrals]')?.classList.remove('hidden');
          break;
        case 'referrer-error':
          referrer.showError({ error: 'Something went wrong. Please try again.' });
          break;
      }
    }

    function runInviteAction(action, invite) {
      switch (action) {
        case 'invite-welcome':
          invite.setWelcomeCopy({ firstName: 'Alex', lastName: 'Referrer' });
          invite.showWelcomeForGuest();
          break;
        case 'invite-loading-referrer':
          invite.showStep('loading-referrer');
          break;
        case 'invite-loading-eligibility':
          invite.showStep('loading-eligibility');
          break;
        case 'invite-signup':
          invite.setSubmitting(false);
          referAFriendClearInlineError(invite);
          invite.showStep('signup');
          break;
        case 'invite-signup-error':
          referAFriendSetInlineError(invite, {
            error: 'Please fix the errors below.',
            details: ['First name is required', 'Email must be a valid email address'],
          });
          invite.showStep('signup');
          break;
        case 'invite-loading-signup':
          invite.showStep('loading-signup');
          break;
        case 'invite-ineligible':
          invite.showIneligible(testIneligibleReason);
          break;
        case 'invite-success':
          invite.populateSuccess(testDiscountCode);
          invite.showStep('success');
          break;
        case 'invite-success-redeemed':
          invite.setSuccessVariant('redeemed');
          invite.showStep('success');
          break;
        case 'invite-missing-ref':
          invite.showStep('missing-ref');
          break;
        case 'invite-error':
          invite.showError({ error: 'Something went wrong. Please try again.' });
          break;
      }
    }

    panel.addEventListener('change', (event) => {
      const select = event.target.closest('[data-raf-dev-select]');
      if (!select || !select.value) return;

      const action = select.value;
      const { referrer, invite } = getComponents();

      if (action.startsWith('referrer-') && referrer) {
        runReferrerAction(action, referrer);
      }

      if (action.startsWith('invite-') && invite) {
        runInviteAction(action, invite);
      }
    });

    updateTargetLabel();

    window.customElements.whenDefined('refer-a-friend-referrer').then(updateTargetLabel).catch(() => {});
    window.customElements.whenDefined('refer-a-friend-invite').then(updateTargetLabel).catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReferAFriendDevTools);
  } else {
    initReferAFriendDevTools();
  }

  } catch(e) { console.error(e); }
})();
})();
